import classNames from 'classnames';
import styles from './PersonaForm.module.css';
import { CommonFormProps } from './useCommonState';
import { CtaButton } from 'admin/shared-components/CtaButton/CtaButton';

type ControlProps = {
  editMode: boolean;
  canRevert: boolean;
  revertChanges: () => void;
  type: 'title' | 'scim';
} & Pick<CommonFormProps, 'setEditMode' | 'setPersonaFormState'>;

export default function Control({
  editMode,
  canRevert,
  revertChanges,
  type,
  setEditMode,
  setPersonaFormState,
}: ControlProps) {
  return (
    <div className={classNames(styles.personaButtons)}>
      {editMode ? (
        <CtaButton primary label="Save" type="submit" />
      ) : (
        <CtaButton
          primary
          label="Edit"
          type="button"
          onClick={(e) => {
            e?.preventDefault();
            setEditMode(true);
          }}
        />
      )}
      <CtaButton
        primary={false}
        label="Cancel"
        onClick={() => setPersonaFormState({ display: false, type })}
      />
      {canRevert && (
        <CtaButton primary={false} label="Revert Changes" onClick={() => revertChanges()} />
      )}
    </div>
  );
}
